import createConverter from './lib/create_converter';
import SnippetRevision from 'models/snippet_revision';

export default createConverter(SnippetRevision);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/snippet_revision_converter.js